import { signal } from 'services/SignalsService'
import { SpinCheckService } from 'services/SpinCheckService'

const name = 'AWAIT-SPIN'

async function execute() {
  return new Promise((resolve) => {
    function trySpin() {
      if (SpinCheckService.checkBalance()) {
        resolve(game.models.ModeModel.auto)
        signal.off('BUTTON:spin', trySpin)
      }
    }

    function tryBuyFeature() {
      if (SpinCheckService.checkBuyBalance()) {
        resolve()
        game.models.ModeModel.buyFeature = true
        signal.off('BUTTON:spin', trySpin)
      }
    }

    function tryGamble() {
      resolve()
      signal.off('BUTTON:spin', trySpin)
    }

    signal.on('BUTTON:BuyButton', tryBuyFeature)
    signal.on('BUTTON:spin', trySpin)
    signal.on('GAMBLE-FEATURE:GET-CARD', tryGamble)
  })
}

export function getAwaitSpinAction() {
  return {
    name,
    execute,
  }
}
